import React, { createContext, useContext, useState, useCallback, useEffect } from 'react'
import { Snackbar } from '@material-ui/core'
import Toast from '../components/toast/toast'
import { ApiResponse } from '../data-access/api-request-types'

type ToastVariants = 'success' | 'info' | 'warning' | 'error' | undefined

export interface IToast {
  message?: string
  variant: ToastVariants
  translationKey?: string
  autoHideDuration?: number
}

interface IToastContext {
  addToast: (toast: IToast) => void
  toastOnError: <T>(apiResponse: ApiResponse<T>) => ApiResponse<T>
}

const ToastContext = createContext<IToastContext>({} as IToastContext)

export const useToastContext = () => useContext(ToastContext)

export const ToastContextProvider: React.FC = ({ children }) => {
  const [toasts, setToasts] = useState<IToast[]>([])
  const [isTimeoutSet, setIsTimeoutSet] = useState(false)

  const addToast = (toast: IToast) => {
    setToasts([...toasts, toast])
  }

  useEffect(() => {
    if (!isTimeoutSet && toasts.length > 0) {
      setIsTimeoutSet(true)
      setTimeout(() => {
        setToasts([])
        setIsTimeoutSet(false)
      }, 10000)
    }
  }, [isTimeoutSet, toasts])

  const toastOnError = useCallback(<T,>(apiResponse: ApiResponse<T>) => {
    if (apiResponse.error) {
      addToast({
        variant: 'error',
        message: apiResponse.error.message,
      } as IToast)
    }

    return apiResponse
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const snackbarOpen = Object.keys(toasts).length > 0

  return (
    <ToastContext.Provider value={{ addToast, toastOnError }}>
      <Snackbar open={snackbarOpen}>
        <div className="toasts">
          {toasts.map((toast, index) => {
            return <Toast toast={toast} key={index} />
          })}
        </div>
      </Snackbar>

      {children}
    </ToastContext.Provider>
  )
}
